import { atom, useRecoilState } from 'recoil';

import { useMediaQuery, useTheme } from '@mui/material';

import { PrimaryNavStore } from './types';

export const isDrawerLockedAtom = atom<boolean>({
  key: 'is-drawer-locked',
  default: false,
});

export const isDrawerOpenAtom = atom<boolean>({
  key: 'is-drawer-open',
  default: false,
});

const isClientActionsSubMenuOpenAtom = atom<boolean>({
  key: 'is-client-actions-sub-menu-open',
  default: false,
});

const isSupportSubMenuOpenAtom = atom<boolean>({
  key: 'is-support-sub-menu-open',
  default: false,
});

const navItemsStateAtom = atom<string[]>({
  key: 'nav-items-state',
  default: [],
});

const switchAccountModalIsOpenAtom = atom<boolean>({
  key: 'switch-account-modal-is-open',
  default: false,
});

const usePrimaryNavStore = (): PrimaryNavStore => {
  const [isDrawerLocked, setIsDrawerLocked] =
    useRecoilState(isDrawerLockedAtom);

  const [isClientActionsSubMenuOpen, setIsClientActionsSubMenuOpen] =
    useRecoilState(isClientActionsSubMenuOpenAtom);

  const [isSupportSubMenuOpen, setIsSupportSubMenuOpen] = useRecoilState(
    isSupportSubMenuOpenAtom,
  );

  const [isDrawerOpen, _setIsDrawerOpen] = useRecoilState(isDrawerOpenAtom);

  const [navItemsState, setNavItemsState] = useRecoilState(navItemsStateAtom);

  const [switchAccountModalIsOpen, setSwitchAccountModalIsOpen] =
    useRecoilState(switchAccountModalIsOpenAtom);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const collapsedPrimaryNavWidth = isSmallScreen
    ? theme.primaryNav.smallNavClosedWidth
    : theme.primaryNav.navClosedWidth;

  const primaryNavOffset = isDrawerLocked
    ? theme.primaryNav.navOpenWidth
    : collapsedPrimaryNavWidth;

  const setIsDrawerOpen = (isOpen: boolean) => {
    if (isOpen) {
      setIsClientActionsSubMenuOpen(false);
      setIsSupportSubMenuOpen(false);
    }
    _setIsDrawerOpen(isOpen);
  };

  return {
    isClientActionsSubMenuOpen,
    isSupportSubMenuOpen,
    isDrawerLocked,
    isDrawerOpen,
    navItemsState,
    setIsClientActionsSubMenuOpen,
    setIsSupportSubMenuOpen,
    setIsDrawerLocked,
    setIsDrawerOpen,
    setNavItemsState,
    switchAccountModalIsOpen,
    setSwitchAccountModalIsOpen,
    primaryNavOffset,
  };
};

export default usePrimaryNavStore;
